import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=48103c18&scoped=true&"
import script from "./TheHeader.vue?vue&type=script&lang=ts&"
export * from "./TheHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=48103c18&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48103c18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheLogo: require('/app/src/components/global/TheLogo.vue').default,EsTenantPicker: require('/app/src/components/global/EsTenantPicker.vue').default,EsCreateButton: require('/app/src/components/common/EsCreateButton.vue').default,TheDarkModeButton: require('/app/src/components/global/TheDarkModeButton.vue').default,TheFavorites: require('/app/src/components/global/TheFavorites.vue').default,EsHelpDropdown: require('/app/src/components/global/EsHelpDropdown.vue').default,TheAnnouncekit: require('/app/src/components/global/TheAnnouncekit.vue').default,EsUserSettingsDropdown: require('/app/src/components/global/EsUserSettingsDropdown.vue').default,EsLink: require('/app/src/components/common/EsLink.vue').default,EsButton: require('/app/src/components/common/EsButton.vue').default})
